import axios from 'axios'
import {Message} from 'element-ui'
export const uploadImg = (file, fileSize) => {
    fileSize=fileSize||200;
  if(file && file.size>fileSize*1024*1024){
    Message({
      message: '请上传小于'+fileSize+'M的附件',
      type: 'error',
      duration: 2000,
      onClose: () => { }
    })
    return new Promise(function(resolve, reject) {
      reject()
    })
  }
    if(file){
        return new Promise(function(resolve, reject) {
            //1。 请求服务端获取上传地址 POST JSON
            let postData = {
                content_type:file.type ? file.type : '*/*',
                file_name:file.name
            }
            axios.post('https://uploads.enlightv.com/get_upload_url', postData).then(res => {
                if(res.data.upload_url){
                    axios.put(res.data.upload_url, file, {
                        headers: {
                            "Content-Type": file.type ? file.type : '*/*',
                            'x-oss-storage-class': 'Standard',
                        }
                    })
                        .then(function(response) {
                            // 处理成功
                            let returnData={
                                file_path:res.data.url,
                                file_name:file.name,
                                file_type:file.type
                            }
                            resolve(returnData)
                        })
                        .catch(function(error) {
                            // 处理错误
                        });
                }
            }).catch(err => {
                if (!err.response) {

                } else {
                    reject(err.data)
                }
            })
        })
    } else {
        return new Promise(function (resolve, reject) {
            reject()
        })
    }
}

export const getOSSData = (filePath, fileName) => {
    window.location.href = `${filePath}?response-content-disposition=attachment%3B%20filename%3D${fileName}`
}
